import CalendarTodayRoundedIcon from "@mui/icons-material/CalendarTodayRounded";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import { Stack, Typography } from "@mui/material";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis";
import UserAvatar from "@entrilia/shared/components/UserAvatar";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import type { WorkbookTemplate } from "../../../../../api/types/workbookRuns.types";
import WorkbookDetailsField from "../../common/WorkbookDetailsField";

interface Props {
  workbookTemplate: WorkbookTemplate;
}

const WorkbookTemplateDetailsMeta = ({ workbookTemplate }: Props) => {
  return (
    <Stack>
      <Typography variant="h6" sx={{ py: 2 }}>
        Template Details
      </Typography>
      <Stack spacing={0.5}>
        <WorkbookDetailsField
          Icon={PersonOutlineRoundedIcon}
          fieldName="Created by"
          FieldValue={
            <>
              <UserAvatar size="small" userName={workbookTemplate.createdBy} />
              <Typography>{workbookTemplate.createdBy}</Typography>
            </>
          }
        />
        <WorkbookDetailsField
          Icon={CalendarTodayRoundedIcon}
          fieldName="Created at"
          FieldValue={<TypographyTooltipEllipsis text={convertISODateTime(workbookTemplate.createdAt)} />}
        />
      </Stack>
    </Stack>
  );
};

export default WorkbookTemplateDetailsMeta;
